import React from "react";

const Experience = ({ classicHeader, darkTheme }) => {
    const experienceDetails = [
        {
            yearRange: "2024 - Present",
            title: "Utilities Systems Leader",
            company: {
                name: "Brass Engineering",
                url: "https://brassengineering.com/"
            },
            place: "Belo Horizonte City, Minas Gerais, Brazil",
            desc: `Key Responsibilities:

\u2022 Time and scope management for the execution team.
\u2022 Personnel allocation planning to meet project demands.
\u2022 Schedule verification and adjustments to ensure alignment with project milestones.
\u2022 Preparation of execution progress reports.
\u2022 Technical and managerial coordination with clients, suppliers, and internal teams.
\u2022 Review and commenting on 3D models of utility systems and equipment.
\u2022 Supplier engagement for equipment selection and specification.
\u2022 Quality assurance of engineering deliverables.
\u2022 Drafting and management of contractual amendments.
\u2022 Preparation and review of engineering documentation.
\u2022 Execution of on-site field visits and inspections.
\u2022 Development of technical assessments and recommendations for utility equipment.
\u2022 Analysis and validation of documentation submitted by suppliers.`,
        },
        {
          yearRange: "2023 - 2024",
            title: "Utilities Systems and Piping Leader",
            company: {
                name: "TRENG Consulting and Technology in Projects",
                url: "https://trengy.com.br/"
            },
          place: "Belo Horizonte City, Minas Gerais, Brazil",
          desc: `Leader of Utility Systems and Piping Disciplines in Mining Projects

\u2022 Leadership of utility systems and piping disciplines in multidisciplinary projects for the mining industry.
\u2022 Analysis of execution schedules to define realistic deadlines and ensure efficient allocation of personnel.
\u2022 Development of detailed work plans to establish clear, structured, and achievable scopes.
\u2022 Technical support to engineering teams, aiming to enhance development quality and overall efficiency.
\u2022 Active participation in technical and management alignment meetings with clients and internal stakeholders.
\u2022 Support to cost estimation and budgeting teams by identifying technical requirements for proposal development.
\u2022 Review and quality assurance of engineering documents to ensure compliance with project standards and deliverables.
\u2022 Coordination of candidate interviews for team expansion and qualification validation.
\u2022 Management of outsourced teams involved in the preparation of engineering documentation.
\u2022 Continuous assessment of team productivity, including monitoring of hours worked, evaluation of performance indicators, and accountability through survey-based metrics.

Projects I Participated In:

\u2022 Pebble Recrushing Project (Aurizona).
\u2022 Water Pumping from Santo Antonio Dam to the Sampler at Plant 1 (Kinross).
\u2022 Pumping from Tank C3 to Tank C1 (Kinross).
\u2022 Pumping from Tank C3 to the Plant (Kinross).
\u2022 Corrego Rico Pumping System (Kinross).
\u2022 New Tailings Filtration Plant (MRDM).
\u2022 Fire Protection System with Automatic Sprinkler Systems (Vale) (SDACI) TR-1085KS-05 (Vale).
\u2022 Service Water System \u2013 S11D Project (Vale).
\u2022 Fire Protection System Upgrade \u2013 Sossego Mine (Vale).
\u2022 HVAC Upgrade for Hydraulic Rooms \u2013 Vargem Grande (Vale).
\u2022 Fire Protection System \u2013 Nova Era (Vale).
\u2022 Fire Protection System \u2013 Explosives Storage \u2013 Sossego (Vale).
\u2022 New Pulping Sump \u2013 Vargem Grande (Vale).
\u2022 Fire Protection System \u2013 Porto Velho (Vale).
\u2022 Compressor Room Upgrade \u2013 Grinding and Additives Area \u2013 Ponta da Madeira (Vale).
\u2022 Fire Protection System \u2013 Distribution Center in Barao de Cocais (Vale).
\u2022 Welding Yard Renovation \u2013 Governador Valadares (Vale).
\u2022 Sprinkler System for the Timbopeba Loadout Silo (Vale).
\u2022 DEM Study of Link Conveyor \u2013 S11D (Vale).
\u2022 AVCB Compliance Regularization \u2013 Brucutu Mine (Vale).`,
        },
        {
            yearRange: "2021 - 2023",
            company: {
                name: "Brass Engineering",
                url: "https://brassengineering.com/"
            },
            title: "Utility Systems Engineer",
            place: "Belo Horizonte City, Minas Gerais, Brazil",
            desc: `Development of projects for the Utilities Systems discipline including the production of project documents such as calculation memorials, P&ID, technical specifications for equipment and services, definitions of standards and project criteria, and also a constant planning follow-up. Conducting external and internal technical alignment meetings, as well as project presentations for clients and peers.

Projects I Participated In:
            
\u2022 Tailings Dam Number 8 (CBMM).
\u2022 Tailings Dam Number 9 (CBMM).
\u2022 Expansion of the Homogenization Yard (CBMM).
\u2022 Relocation of Support Structures \u2013 Periquito Mine (Vale).
\u2022 Total Tailings Filtration \u2013 Timbopeba (Vale).
\u2022 Fire Protection System \u2013 Ore Moisture Reduction System (Vale).
\u2022 Productive Capacity Expansion (MRN).
\u2022 Tailings Disposal and Industrial Drainage (Anglo American).
\u2022 Reagent Dosing \u2013 EB2 (Anglo American).
\u2022 Raw Material Storage System (CBMM).
\u2022 Tailings Dam Number 9 (CBMM).`,
        },
        {
            yearRange: "2021 - 2021 (7 months)",
            company: {
                name: "TRENG Consulting and Technology in Projects",
                url: "https://trengy.com.br/"
            },
            title: "Utility System Engineer",
            place: "Belo Horizonte City, Minas Gerais, Brazil",
            desc: `On my first stint at Treng I worked on developing technical documents for HVAC discipline projects, performing structural calculations using the finite element method (FEM), and analyzing flow structures using the discrete element method (DEM). I was responsible for the production of project documents, including calculation memorials, technical specifications for equipment and services, and the definition of standards and project criteria. Additionally, I conducted external and internal technical alignment meetings, and delivered project presentations  for clients and peers.

Projects I Participated In:

\u2022 HVAC Project for Rolling Mill II (Sinobras)
\u2022 Revitalization of Fuel Stations at Salobo Site (Vale)
\u2022 Flow Simulation and Discharge Chute Redesign \u2013 TR-1080KS-37 (Vale)
\u2022 Flow Simulation and Discharge Chute Redesign \u2013 TR-1081KS-11@14 (Vale)
\u2022 HVAC System for Central Office \u2013 Mutuca Mine (Vale)
\u2022 HVAC System for Brucutu Mine Cafeteria (Vale)
\u2022 HVAC System for Temporary Training Center \u2013 Caue Mine (Vale)
\u2022 HVAC System for Cafeteria \u2013 Conceicao Mine (Vale)
\u2022 HVAC System for Locker Rooms \u2013 Conceicao Mine (Vale)
\u2022 HVAC System for Cafeteria \u2013 Brucutu Mine (Vale)
\u2022 Flow Simulation and Chute Redesign \u2013 TR-1081KS-11@14 (Vale)`,
        },
        {
            yearRange: "2020 - 2021 (1 year, 1 month)",
            company: {
                name: "OpenCAE Engineering",
                url: null
            },
          title: "Mechanical Engineer",
          place: "Belo Horizonte City, Minas Gerais, Brazil",
          desc: `I worked on developing DEM conceptual software for engineering and simulating granular flow systems for mining companies, as well as FEM studies for structural analyses.`,
        },
        {
          yearRange: "2017 - 2020 (3 year, 1 month)",
            company: {
                name: "Conep Project Consultancy",
                url: "https://conep.com.br/"
            },
          title: "Mechanical Engineer",
          place: "Belo Horizonte City, Minas Gerais, Brazil",
          desc: `I worked on projects involving structural and mechanical systems using the finite element method (FEM).
I have carried out projects and verified granular material transport systems, using the discrete element method (DEM).
I implemented design and flexibility calculations for piping and pumping systems.
I executed a considerable number of hydraulic projects for mining and steel companies.`,
        },
        {
            yearRange: "2016 - 2017 (1 year, 1 month)",
            company: {
                name: "Oxiban Industrial Gases",
                url: null
            },
          title: "Technical Seller",
          place: "Belo Horizonte City, Minas Gerais, Brazil",
          desc: `I was responsible for the assembly and preparation of oxy-acetylene welding equipment. I handled prospecting new customers, closed deals, and ensured high-quality customer service and loyalty. I also managed post-sales as well as storage replenishment to maintain adequate inventory levels.`,
        },
    ];

  return (
    <section
      id="experience"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
      style={{pageBreakBefore: 'always'}}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Experience
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            Experience
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gx-5">
          {/* My Experience */}
          <div className="col-md-12">
            {/*<h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              My Experience
            </h2>*/}
            {experienceDetails.length > 0 &&
              experienceDetails.map((value, index) => (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                    <p>
                          {value.company.url ? (
                              <a href={value.company.url} target="_blank" rel="noopener noreferrer">
                                  {value.company.name}
                            </a>
                        ) : (
                                  <span>{value.company.name}</span>
                        )}
                    </p>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                    {value.desc}
                  </p>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
